"use client";

import { Maximize2Icon, SquarePenIcon, Trash2Icon } from "lucide-react";
import { useTranslations } from "next-intl";

// Hover overlay shown on an uploaded image preview. Always visible on touch
// screens, since there is no hover there. The parent needs `relative group`.
export function UploadThumbnailActions({
	onPreview,
	onEdit,
	onDelete,
}: {
	onPreview: () => void;
	onEdit?: () => void;
	onDelete?: () => void;
}) {
	const t = useTranslations("aiImageGenerator.client.imageSettings.upload");

	const actions = [
		{
			key: "preview",
			label: t("actions.preview"),
			icon: Maximize2Icon,
			onClick: onPreview,
		},
		{
			key: "edit",
			label: t("actions.edit"),
			icon: SquarePenIcon,
			onClick: onEdit,
		},
		{
			key: "delete",
			label: t("actions.delete"),
			icon: Trash2Icon,
			onClick: onDelete,
		},
	];

	return (
		<div className="absolute inset-0 flex items-center justify-center gap-2 bg-black/30 opacity-100 transition-opacity sm:opacity-0 sm:group-hover:opacity-100">
			{actions
				.filter((action) => action.onClick)
				.map(({ key, label, icon: Icon, onClick }) => (
					<button
						key={key}
						type="button"
						title={label}
						aria-label={label}
						onClick={(e) => {
							e.stopPropagation();
							onClick?.();
						}}
						className="rounded-full bg-black/50 p-2 text-white transition-colors hover:bg-black/70"
					>
						<Icon className="h-4 w-4" />
					</button>
				))}
		</div>
	);
}
